import { BaseObject, SafeBaseObject } from '@common/models/base-object.models';
import { DateTime } from 'luxon';
import { IReservationApiParametersBookCamp, IReservationApiParametersRoomConfHdr, IReservationApiParametersSuite } from './res-booking.model';

export class ReservationOptionCost extends SafeBaseObject {
  cost = 0;
  costIsNull = true
  currency = '';
  date = DateTime.invalid('empty');
  dateCost = DateTime.invalid('empty');
  optionCostPerDayID = 0;
  optionID = 0;
  optionName = '';
  serviceID = 0;
  supplierID = 0;
  hasBkg = false;
  stoPerc = 0;

  get costDisplay() {
    if (this.costIsNull) return null
    return this.cost
  }
  constructor(data?: any) {
    super();
    if (data) {
      this.updateData(data);
      this.costIsNull = data.Cost === null
    }
  }
}
export class ReservationOptionPrice extends BaseObject {
  price: number;
  currency: string;
  date: DateTime;
  datePrice: DateTime;
  pricePerDateID: number;
  optionID: number;
  optionName: string;
  serviceID: number;
  priceTypeID: number
  margin: number;
  rOE: number;
  snglSuppCommPerc: number;
  snglSuppType: string;
  snglSuppValue: number;


  constructor(data: IReservationApiOptionPrice) {
    super();
    this.price = 0;
    this.currency = '';
    this.date = DateTime.min();
    this.datePrice = DateTime.min();
    this.pricePerDateID = 0;
    this.optionID = 0;
    this.optionName = '';
    this.serviceID = 0;
    this.priceTypeID = 0;
    this.margin = 0;
    this.rOE = 0;
    this.snglSuppCommPerc = 0;
    this.snglSuppType = '';
    this.snglSuppValue = 0;
    if (data) this.updateData(data);
  }

  override updateData(data: IReservationApiOptionPrice): void {
    this.addMangledProperty(data);
    this.addDateTimeProperty('date', data, 'Date');
    this.addDateTimeProperty('datePrice', data, 'DatePrice');
  }

  get marginPercentage(): string {
    return this.margin != null ? `${this.margin}%` : '';
  }
}

export interface IReservationApiOptionPrice {
  Price?: number;
  Currency?: string;
  Date?: DateTime;
  DatePrice?: DateTime;
  PricePerDateID?: number;
  OptionID?: number;
  OptionName?: string;
  ServiceID?: number;
  PriceTypeID?: number;
  ROE?: number;
  SnglSuppCommPerc?: number;
  SnglSuppType?: string;
  SnglSuppValue?: number;
}

export interface IReservationGetBkgServicesParams {
  BkgID?: number;
  SectionID?: number;
  ServiceTypeID?: number;
  SearchText?: string;
  SupplierID?: number,
  SupplierName?: string;
  OptionName?: string;
  DateFrom?: DateTime;
  DateTo?: DateTime;
  CountryCod?: string;
  CityID?: number;
  CitiesID?: string;

  PageNum?: number
  PageSize?: number
}

export interface IReservationGetBkgOptionsParams {
  BkgID?: number;
  SectionID?: number;
  ServiceID?: number;
  SearchText?: string;
  DateFrom?: DateTime;
  DateTo?: DateTime;
  SupplierName?: string;
  OptionName?: string;
}
export interface IReservationAddServiceOptionParams {
  BkgID?: number;
  VersionID?: number;
  PackageOptions?: IReservationAddServiceOptionPackageParams[];
  ServiceIncluded?: IReservationAddServiceOptionPackageParams[];
  LoyaltyRedemption?: IReservationAddServiceOptionLoyaltyRedemption[];
  Certificate?: IReservationAddServiceOptionCertificate[];
  GuestCod?: string;
  Alternative?: string;
  NewSuite?: IReservationApiParametersSuite[]
  BookCamp?: IReservationApiParametersBookCamp[]
  KeySuiteID?: number;
  RoomID?: number;
  SuiteNum?: string;
  NewPriceTypeID?: number
  WL?: string
  RoomConfHdr: IReservationApiParametersRoomConfHdr[]
  TMStartDate?: DateTime
}

export interface IReservationAddServiceOptionLoyaltyRedemption {
  OptionCod?: string;
  IndividualID?: number;
  TierID?: number;
  Note?: string;
}

export interface IReservationAddServiceOptionCertificate {
  CertificateID: number;
  BkgID: number;
  GuestCod: string;
  Amount: number;
  CurrencyCod: string;
}

export interface IReservationEditServiceOptionParams {
  BkgID?: number;
  SectionID?: number;
  Items?: IReservationEditServiceOptionItem[];
}

export interface IReservationEditServiceOptionItem {
  ItemID?: number;
  ItineraryDate?: DateTime;
  SellingPrice?: string;
  Commissionable?: string;
  ForcedSupplierID?: number;
}

export interface IReservationDeleteOptionPackageParams {
  BkgID?: number;
  GuestCod?: string;
  VersionID?: number;
  PackageOptions?: IReservationEditServiceOptionItem[];
}

export interface IReservationDeleteServiceOptionItem {
  ServiceID?: number;
  OptionID?: number;
  ItineraryDate?: DateTime;
  GuestCod?: string;
}

export interface IReservationAddServiceOptionPackageParams {
  ServiceID?: number;
  OptionID?: number;
  VoyageID?: number
  PackageID?: number
  PackageTravelDateID?: number
  ItineraryDate?: DateTime;
  Price?: number;
  Markup?: number;
  SBCMessage?: string;
  Quantity?: number;
  GuestTo?: string
  Alternative?: string
}
export interface IReservationUpdateMessageParams {
  BkgID?: number;
  OptionID?: number;
  ItemID?: number;
  GuestCod?: string;
  SectionID?: number;
  Message?: string;
  FileGuid?: string;
  FileId?: number;
  FileName?: string;
}




export interface IReservationApiCloneServices {
  ServiceID: number
}

export interface IReservationApiGetOptions {
  ServiceID?: number;
  OptionID?: number;
  MinPax?: number;
  MaxPax?: number;
  OptionName?: string;
  OptionShortName?: string;
  OptionDesc?: string;
  Commissionable?: string;
  Refundable?: string;
  IsSBC?: string;
  IsIncluded?: string;
  IsActive?: string;
}

export interface IReservationApiGetOptionCost {
  ServiceID?: number;
  OptionID?: number;
  Year?: number;
  GridView?: string;
}


export interface IReservationApiManageV2OptionCost {
  ServiceID?: number;
  OptionID?: number;
  Year?: number;
  CostSetup?: IReservationApiCostPriceSetup[]
  ToDel?: string;
}
export interface IReservationApiManageV2OptionPrice {
  ServiceID?: number;
  OptionID?: number;
  Year?: number;
  PriceTypesID?: string;
  PriceTypeID?: number;
  PriceSetup?: IReservationApiCostPriceSetup[];
  CurrencySetup?: IReservationCurrencySetup[];
  PriceSetupID?: number;
  CurrencyCod?: string;
}

export interface IReservationApiCostPriceSetup {
  PerDayID?: number;
  OptionID?: number;
  ServiceID?: number;
  DateStart?: string; // date per availability
  DateEnd?: string; // date per availability
  DateFrom?: DateTime; // date per cost
  DateTo?: DateTime; // date per cost
  Cost?: string | null;
  Currency?: string;
  PriceTypeID?: number;
  PriceSetUpID?: number;
  Margin?: string;
  ROE?: string;
  Price?: string;
  Status?: 'A' | 'D';
  SnglSuppCommPerc?: number;
  SnglSuppType?: string;
  SnglSuppValue?: number;
  StoPerc?: number;
}

export interface IReservationCurrencySetup {
  Currency: string;
  Margin: number;
  ROE: number;
  FixedPrice: number;
}

export interface IReservationApiGetOptionPrice {
  ServiceID?: number;
  OptionID?: number;
  Year?: number;
  CurrencyCod?: string;
  PriceTypeID?: number;
}
export interface IReservationSuiteType {
  VoyageID: number;
  SuiteNumber?: number | undefined;
  SuiteCategoryID?: number;
  SuiteCategoryCod?: string | undefined;
  SuiteCapacityID?: number;
  IsGty: string;
}

export interface IReservationCheckComboAvailabilityParams {
  BkgID?: number;
  VersionID?: number;
  NewSuite: Array<IReservationSuiteType>
}

export class ReservationOptionAvailability extends SafeBaseObject {
  availabilitybyOptionID = 0;
  date = DateTime.invalid('empty');
  dateAvl = DateTime.invalid('empty');
  propertyID = 0;
  optionID = 0;
  serviceID = 0;
  initialQTY = 0;
  onHoldQTY = 0;
  initialAllotmentQTY = 0;
  onHoldAllotmentQTY = 0;
  priceTypeID = 0;
  agencyID = 0;
  usedQuantity = 0;
  usedQuantityBySpl = 0;

  constructor(data: any) {
    super();
    if (data) this.updateData(data);
  }
}

export interface IReservationApiOptionAvailability {
  AvailabilitybyOptionID?: number;
  Date?: DateTime;
  PropertyID?: number;
  OptionID?: number;
  ServiceID?: number;
  InitialQTY?: number;
  OnHoldQTY?: number;
  InitialAllotmentQTY?: number;
  OnHoldAllotmentQTY?: number;
  PriceTypeID?: number;
  AgencyID?: number;
  Status?: 'A' | 'D';
  ERES_AllocationCode?: string;
  ERES_AgencyCod?: string;
  ERES_RateCode?: string;
}
export interface IReservationApiOptionAllocation {
  AllocationbyOptionID?: number;
  Date?: DateTime;
  PropertyID?: number;
  OptionID?: number;
  ServiceID?: number;
  InitialAllotmentQTY?: number;
  OnHoldAllotmentQTY?: number;
  Status?: string;
  PackageID?: number;
  PackageTravelDateID?: number
  Reason?: string;
  ERES_AllocationCode?: string;
  ERES_AgencyCod?: string;
  ERES_RateCode?: string;
}

export interface IReservationApiGetOptionAvailability {
  ServiceID?: number;
  OptionID?: number;
  Year?: number;
  GridView?: string;
}
export interface IReservationApiGetOptionAllocation {
  ServiceID?: number;
  OptionID?: number;
  Year?: number;
}
export interface IReservationApiGetAllocationByOption {
  ServiceID: number;
  OptionID: number;
  Year?: number;
  PackageID?: number;
  DateFrom?: DateTime;
  DateTo?: DateTime;
  OnlyPkg?: string;
  Daily?: string;
}

export interface IReservationApiGetPriceDayByDay {
  ServiceID?: number;
  OptionID?: number;
  PriceTypeID?: number;
  Currency?: string;
  Year?: number;
  Page?: number;
  PageSize?: number;
}

export interface IReservationApiGetCostPerPax {
  ServiceID?: number;
  OptionID?: number;
  Year?: number;
  Currency?: string;
}

export interface IReservationApiGetOptionAllocationDetails {
  ServiceID?: number;
  OptionID?: number;
  PackageID?: number;
  DateFrom?: DateTime;
  DateTo?: DateTime;
}

export interface IReservationApiManageOptionAvailability {
  Availabilities: IReservationApiOptionAvailability[],
  Allocations?: IReservationApiOptionAllocation[],
}
export interface IReservationApiManageOptionAllocation {
  Allocations: IReservationApiOptionAllocation[],
  AllChildDates?: string
}


export interface IResApiReplaceOptionsParams {
  Opt2Replace: IResApiReplaceOption[]
  ReplaceByDate: 'Y' | 'N';
}

export interface IResApiReplaceOption {
  BkgID: number;
  ServiceID_OLD: number;
  OptionID_OLD: number;
  ServiceID_NEW: number;
  OptionID_NEW: number;
  ManageAvail: boolean;
  ItineraryDate?: DateTime;
  ItemListID?: string;
}

export interface IResApiReplaceAvailability {
  IsAvl: number;
  BkgID: number;
  ServiceID_OLD: number;
  OptionID_OLD: number;
  Allocation: number;
  Availability: number;
}

export interface IResApiReplaceStatus {
  BkgID: number;
  ServiceID: number;
  OptionID: number;
  Status: 'OK' | 'KO'
  StatusMessage: string;
}

export interface IResApiGetReplaceOptionsHistoryParams {
  BkgID?: number;
  ServiceID_OLD?: number;
  OptionID_OLD?: number;
  ServiceID_NEW?: number;
  OptionID_NEW?: number;
  DateFrom?: DateTime;
  DateTo?: DateTime;
  Status?: 'OK' | 'KO';
}

export class ResReplaceHistory extends SafeBaseObject {
  iD: number = 0;
  [key: string]: any;

  constructor(data?: IResApiReplaceHistory) {
    super();
    if (data) this.updateData(data);
  }
  override updateData(data: IResApiReplaceHistory): void {
    this.addMangledProperty(data);
  }
}

export interface IResApiReplaceHistory {
  ID: number;
}


export interface IReservationGetAllocations {
  ServiceID?: number;
  OptionID?: number;
  Date: DateTime;
  InitialAllotmentQTY: number;
  OnHoldAllotmentQTY: number;
  ServiceName: string;
  OptionName: string;
  PackageNames: string;
}

export class ReservationGetAllocations extends SafeBaseObject {
  serviceID = 0;
  optionID = 0;
  date = DateTime.invalid('empty');
  initialAllotmentQTY = 0;
  onHoldAllotmentQTY = 0;
  serviceName = '';
  optionName = '';
  packageNames = ''
  packageTravelDateID = 0;
  eRESAllocationCode = ''
  eRESAgencyCod = ''
  eRESRateCode = ''

  constructor(data?: IReservationGetAllocations) {
    super();
    if (data) this.updateData(data);
  }
  override updateData(data: IReservationGetAllocations): void {
    this.addMangledProperty(data);
    this.addDateTimeProperty('date', data, 'Date');
    if (data.PackageNames) {
      this.packageNames = data.PackageNames.replace(/\|/g, '\n');
    }
  }
}

export interface IReservationOptionPriceAllocation {
  PackageID: number;
  PackageName: string;
  DateFrom: DateTime;
  DateTo: DateTime;
  InitialAllotmentQTY: number;
  OnHoldAllotmentQTY: number;
  AllocationbyOptionIDs: string;
  CanEdit: string;
  CanDelete: string;
}

export class ReservationOptionPriceAllocation extends SafeBaseObject {
  packageID = 0;
  packageName = '';
  packageTravelDateID = 0;
  travelStartDate = DateTime.invalid('empty');
  date = DateTime.invalid('empty');
  dateFrom = DateTime.invalid('empty');
  dateTo = DateTime.invalid('empty');
  initialAllotmentQTY = 0;
  onHoldAllotmentQTY = 0;
  allocationbyOptionIDs = '';
  canEdit = false;
  canDelete = false;
  travelDateStatus = '';
  eRESAgencyCod?: string;
  eRESAllocationCode?: string;
  eRESRateCode?: string;
  usedQuantity = 0;
  usedQuantityBySpl = 0;

  constructor(data?: IReservationOptionPriceAllocation) {
    super();
    if (data) this.updateData(data);
  }
}

export class ReservationOptionPriceDayByDay extends SafeBaseObject {
  pricePerDateID = 0;
  priceTypeID = 0;
  priceTypeName = '';
  priceSetUp = '';
  priceSetUpID = 0;
  dateFrom = DateTime.invalid('empty');
  dateTo = DateTime.invalid('empty');
  sellingPrice = 0;
  currency = '';
  roe?: number;
  margin?: number;
  startingCost = 0;
  startingCurrency = '';

  constructor(data?: any) {
    super();
    if (data) this.updateData(data);
  }

}

export class ReservationOptionPriceAllocationDetail extends SafeBaseObject {
  packageID = 0;
  packageName = '';
  date = DateTime.invalid('empty');
  initialAllotmentQTY = 0;
  onHoldAllotmentQTY = 0;
  allocationbyOptionID = 0;
  checked?: boolean;
  canEdit?: boolean;
  canDelete?: boolean;
  eRESAllocationCode?: string;
  eRESAgencyCod?: string;
  eRESRateCode?: string;
  packageTravelDateID?: number;

  constructor(data?: any) {
    super();
    if (data) this.updateData(data);
  }
}

export class ReservationOptionCostPerPax extends SafeBaseObject {
  optionCostPerPaxID = 0;
  serviceID = 0;
  serviceName = '';
  optionID = 0;
  optionName = '';
  dateFrom = DateTime.invalid('empty');
  dateTo = DateTime.invalid('empty');
  cost = 0;
  currency = '';
  guestFrom = 0;
  guestTo = 0;
  details: { guestFrom: number, guestTo: number, cost: number, dateFrom: DateTime, dateTo: DateTime, indexDetail: number }[] = [];

  constructor(data?: any) {
    super();
    if (data) this.updateData(data);
  }
}
export interface IReservationApiManageBandCost {
  ServiceID: number;
  OptionID: number;
  OptionCostPerPax: IReservationOptionCostPerPax[]
}

export interface IReservationOptionCostPerPax {
  OptionCostPerPaxID?: number;
  ServiceID?: number;
  OptionID?: number;
  Cost?: number;
  Currency?: string;
  GuestFrom?: number;
  GuestTo?: number;
  StartDate?: DateTime;
  EndDate?: DateTime;
  DateFrom?: DateTime;
  DateTo?: DateTime;
  Status?: string;
}

export class ResPriceSetupBookingList extends SafeBaseObject {
  packageID = 0;
  packageTravelDateID = 0;
  travelStartDate = DateTime.invalid('empty');
  travelEndDate = DateTime.invalid('empty');
  bkgID = 0;
  ownerType = '';
  agencyCod = '';
  agency = '';
  bkgStatus = '';
  directID = 0;
  guests = '';
  passportNumber = '';
  passportIssuePlace = '';
  passportIssueDate = DateTime.invalid('empty');
  passportExpireDate = DateTime.invalid('empty');
  chkAirDet = false;
  suiteNO = '';
  hasPreference = false;
  packageName = '';

  itemStatus = '';
  date = DateTime.invalid('empty');
  serviceName = '';
  optionName = '';

  constructor(data?: any) {
    super();
    if (data) this.updateData(data);
  }
}

export interface IResApiGetPriceSetupBookingListParams {
  PackageID?: number;
  PackageTravelDateID?: number;
  BkgStatus?: string;
  ServiceID?: number;
  OptionID?: number;
  DateFrom?: DateTime;
  DateTo?: DateTime;
  Type?: string;
}

export class ResPackageClearingCruise extends SafeBaseObject {
  packageTypeName: string = '';
  packageID: number = 0;
  packageName: string = '';
  bkgID: number = 0;
  bkgStatus: string = '';
  guestNum: number = 0;
  passengerClass: string = '';
  suiteCategory: string = '';
  suiteCapacity: string = '';
  embarkDate = DateTime.invalid('empty');
  debarkDate = DateTime.invalid('empty');
  travelDateAvailabilityStatus: string = '';
  internalNotes: string = '';
  suiteAvl: number = 0;

  constructor(data?: any) {
    super();
    if (data) this.updateData(data);
  }
}

export class ResPackageClearingNoCruise extends SafeBaseObject {
  packageTypeName: string = '';
  packageID: number = 0;
  packageName: string = '';
  bkgID: number = 0;
  bkgStatus: string = '';
  guestNum: number = 0;
  travelStartDate = DateTime.invalid('empty');
  travelEndDate = DateTime.invalid('empty');
  travelDateAvailabilityStatus: string = '';
  internalNotes: string = '';
  onHoldQTYSingle: number = 0;
  onHoldQTYDouble: number = 0;


  constructor(data?: any) {
    super();
    if (data) this.updateData(data);
  }
}

export class ResPackageClearingVoyage extends SafeBaseObject {
  voyageNumber: string = '';
  embarkDate = DateTime.invalid('empty');
  embarkCity: string = '';
  debarkDate = DateTime.invalid('empty');
  debarkCity: string = '';
  bkgID: number = 0;
  bkgStatus: string = '';
  guestNum: number = 0;
  passengerClass: string = '';
  suiteCategory: string = '';
  suiteCapacity: string = '';
  suiteAvl: number = 0;

  constructor(data?: any) {
    super();
    if (data) this.updateData(data);
  }
}

export class ResSanctuaryCampAllocationDetail extends SafeBaseObject {
  actualDate = DateTime.invalid('empty');
  actualYear: number = 0;
  actualMonth: number = 0;
  propertyLocation: string = '';
  property: string = '';
  roomCategory: string = '';
  roomCategoryID: number = 0;
  allocationID: number = 0;
  inventoryID: number = 0;
  noOfUnits: number = 0;
  allocation: number = 0;
  available: number = 0;
  propertyID: number = 0;
  modifiedDateTime = DateTime.invalid('empty');
  allocationPeriodID: number = 0;
  allocationCode: string = '';
  rateCodeID: number = 0;
  rateCode: string = '';
  rateCodeName: string = '';
  agentCode: string = '';
  agency: string = '';

  constructor(data?: any) {
    super();
    if (data) this.updateData(data);
  }
}

export interface IReservationApiGetSanctuaryCampAllocations {
  PropertyLocation?: string;
  PropertyID?: number;
  SuiteCategoryCod?: string;
  ActualDateFrom?: DateTime;
  ActualDateTo?: DateTime;
  ActualYear?: number;
  ActualMonth?: number;
  AllocationCode?: string;
  RateCode?: string;
  RateCodeName?: string;
  AgencyCode?: string;
  Page?: number;
  PageSize?: number;
}

export class ResSanctuaryCampAllocation extends SafeBaseObject {
  sanctuaryCampAllocationID: number = 0;
  propertyLocation: string = '';
  property: string = '';
  actualDate = DateTime.invalid('empty');
  actualYear: number = 0;
  actualMonth: number = 0;
  propertyID: number = 0;
  roomCategory: string = '';
  roomCategoryID: number = 0;
  inventoryID: number = 0;
  code: string = '';
  PMSCode: string = '';
  units: number = 0;
  booked: number = 0;
  available: number = 0;
  resStatus: number = 0;
  details: ResSanctuaryCampAllocationDetail[] = [];

  constructor(data?: any) {
    super();
    if (data) this.updateData(data);
    if (data?.Details?.length>0) this.details = data.Details.map((detail:any)=>new ResSanctuaryCampAllocationDetail(detail));
  }

}
export class ResSanctuaryCampSuiteCategory extends SafeBaseObject {
  propertyID: number = 0;
  property: string = '';
  propertyCode: string = '';
  suiteCategoryID: number = 0;
  suiteCategory: string = '';
  suiteCategoryCod: string = '';
  shipID: number = 0;

  constructor(data?: any) {
    super();
    if (data) this.updateData(data);
  }
}
export class ResSanctuaryCampAgency extends SafeBaseObject {
  agentID: number = 0;
  agency: string = '';
  agencyCode: string = '';

  constructor(data?: any) {
    super();
    if (data) this.updateData(data);
  }
}
